import { Button } from '@mantine/core';
import { IconPlus } from '@tabler/icons-react';
import { useCreateAndNavToTest } from '~/hooks/api/useCreateAndNavToTest';
import { useProjectId } from '~/hooks/context/useProjectId';

export function HeaderButtons() {
  const projectId = useProjectId();
  const createTestHandler = useCreateAndNavToTest({});

  return projectId ?
      <div className="flex items-center gap-4">
        <Button
          variant="default"
          size="sm"
          onClick={createTestHandler}
          leftSection={<IconPlus size="15" />}
        >
          <span className="text-xs font-medium"> New</span>
        </Button>
      </div>
    : null;
}
